import React, { useEffect, useState } from 'react';
import RefreshIcon from '@atlaskit/icon/core/migration/refresh';
import { Flex, xcss, Text } from '@atlaskit/primitives';
import { useIntl } from '@atlassian/jira-intl';
import { fg } from '@atlassian/jira-feature-gating';
import { formatDistanceStrictWithLocale } from '@atlassian/jira-platform-utils-date-fns/src/main.tsx';
import { useTenantContext } from '@atlassian/jira-tenant-context-controller/src/components/tenant-context/index.tsx';
import messages from './messages.tsx';

type LastRefreshedProps = {
	lastRefreshed: number;
	updateInterval: number;
};

export const LastRefreshed = ({ lastRefreshed, updateInterval }: LastRefreshedProps) => {
	const [lastRefreshedTimeAgo, setLastRefreshedTimeAgo] = useState<string>('');
	const { formatMessage } = useIntl();
	const { locale } = useTenantContext();

	useEffect(() => {
		setLastRefreshedTimeAgo(
			formatMessage(
				fg('jfp_a11y_team_dashboards_hide_refresh_icon')
					? messages.justNowLowerCase
					: messages.justNow,
			),
		);
		const refreshInterval = setInterval(
			() =>
				lastRefreshed != null &&
				setLastRefreshedTimeAgo(
					formatMessage(messages.timeAgo, {
						timeAgo: formatDistanceStrictWithLocale(lastRefreshed, new Date(), locale),
					}),
				),
			updateInterval,
		);
		return () => clearInterval(refreshInterval);
	}, [formatMessage, lastRefreshed, locale, updateInterval]);

	return (
		<Flex direction="row" alignItems="center" xcss={lastRefreshedWrapperStyles}>
			<RefreshIcon
				LEGACY_size="small"
				label={
					fg('jfp_a11y_team_dashboards_hide_refresh_icon')
						? ''
						: formatMessage(messages.lastRefreshedIcon)
				}
				testId="dashboard-internal-common.ui.last-refreshed.refresh-icon"
			/>
			<Text size="UNSAFE_small" color="color.text.subtle">
				{fg('jfp_a11y_team_dashboards_hide_refresh_icon')
					? `${formatMessage(messages.lastRefreshedLabelWithTime, { lastRefreshedTimeAgo })}`
					: lastRefreshedTimeAgo}
			</Text>
		</Flex>
	);
};

const lastRefreshedWrapperStyles = xcss({
	paddingTop: 'space.200',
	color: 'color.text.subtle',
	gap: 'space.050',
});
